 <template>
 <div class="collection">
   <local-remittance
     :bank-info="bankInfo"
     :key = "componentKey"
     @ajax-success="localAjaxSuccess"
   ></local-remittance>
   <bar-info
     bar-title="USDT"
     :channel-info="usdtInfo"
     @ajax-success="ajaxSuccess"
   ></bar-info>
   <bar-info
     bar-title="ChipPay"
     :channel-info="otcInfo"
     @ajax-success="ajaxSuccess"
   ></bar-info>
 </div>
</template>

<script>
import barInfo from "@/components/myFiles/collection/barInfo";
import { mapGetters } from 'vuex';
import {getCustPayTypes} from '@/api/user.js';
import localRemittance from "@/components/myFiles/collection/localRemittance";
export default {
  name: "index",
  components:{
    localRemittance,
    barInfo,
  },
  data() {
    return {
      bankInfo:{},
      usdtInfo: {},
      otcInfo:{},
      componentKey:999
    }
  },
  created() {
    this.queryPayTypes()
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    queryPayTypes(){
      getCustPayTypes({
        custId: this.userInfo.id,
      }).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          if(res.data[i].payTypeId == 4){
            this.bankInfo = res.data[i];
          }
          if(res.data[i].payTypeId == 5){
            this.usdtInfo = res.data[i];
          }
          if(res.data[i].payTypeId == 6){
            this.otcInfo = res.data[i];
          }
          this.componentKey ++;
        }
      })
    },
    ajaxSuccess(){
      this.queryPayTypes();
    },
    localAjaxSuccess(){
      this.queryPayTypes();
    }
  },
}
</script>

<style lang="scss">
.collection {
  .data-line {
    .text-box {
      display: inline-block;
      padding-right: 10px;
    }
  }
}
</style>
